import { Box } from '@/components';
import type { FC, ReactNode } from 'react';

type Props = {
  vertical?: boolean;
  cellRatios?: (number | string)[];
  children: ReactNode[];
  borderWidth?: string;
  borderStyle?: 'dotted' | 'solid';
};

export const FlexCells: FC<Props> = ({
  children,
  vertical,
  cellRatios,
  borderStyle = 'solid',
}) => {
  const borderStyles = {
    [vertical ? 'borderTop' : 'borderLeft']: `1px ${borderStyle} black`,
  };

  const gridTemplateStyle = (cellRatios || [...Array(children.length)].fill(1))
    .map((item) => (typeof item === 'number' ? `${item}fr` : item))
    .join(' ');

  const layoutStyles = vertical
    ? {
        display: 'grid',
        gridTemplateRows: gridTemplateStyle,
        gridTemplateColumns: '1fr',
      }
    : {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridTemplateColumns: gridTemplateStyle,
        gridAutoFlow: 'column',
      };

  return (
    <Box {...layoutStyles} height="100%">
      {children.map((element, index) => (
        <Box
          // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
          key={index}
          {...(!!index && borderStyles)}
          height="100%"
          boxSizing="border-box"
        >
          {element}
        </Box>
      ))}
    </Box>
  );
};
